<div class="container">
  <div class="row">
  <div class="staticPages">

  <div data-language="language == 'bg'" *ngIf="selectedLang === 'bg'">

  <h1>Заведения .бг Контакти</h1>

    <p>
      <img src="https://sofia.zavedenia.com/assets/images/zavedenia-logo.svg">
<br><br>
      Свържете се с нас, ако имате въпроси, а може и препоръки.<br><br>

      <b class="bold">Свържете се с нас, ако сте собственик на заведение.</b> Ще Ви предложим подходящи условия, за да стигнете до вашите клиенти по ефективен начин. Може качествено да представите основните услуги, които предлагате; тип кухня; интересни факти около дейността Ви, както и с какво се различавате от другите заведения? Ако искате да изпъкнете - използвайте допълнително реклама с банери, оферти, присъствие на специалните ни тематични страници. Активирайте онлайн поръчки на храна, както и онлайн резервации - услуги напълно адекватни в сегашните условия.<br> Попитайте как на телефоните по-долу.<br><br>

      <b class="bold">Свържете се с нас, ако сте търговец и/или рекламодател</b> на продукти и услуги свързани със заведения. Ще намерим подходящия канал да стигнете до максимален брой потенциални клинети.<br><br>

      Вече над 15 години опознаваме и се учим от българския ресторантьорски бранш. Отговаряме на техните изисквания, отговаряме и на клиентските такива. Знаем колко много хора, ежедневно търсят заведения през интернет. Било за специален повод или определен тип кухня, конкретен готвач или друго, клиентите винаги проверяват, четат и сравняват преди да вземат решение. В 21 век дистанцията, която интернет скъсява и времето, което пести са благо за всеки.
    </p>

    <div class="contactsInfo">
        <h2>София</h2>
        <b>Георги Дангалаков</b><br>
        /абонаменти и реклама/<br>

        <i class="fa fa-envelope"></i> <a href="mailto:georgid@zavedenia.bg"> georgid&#64;zavedenia.bg</a>
        <br><br>
        <b>Елена Йорданова</b><br>
        /съдържание сайт, счетоводство, nahotel.bg/<br>

        <i class="fa fa-envelope"></i> <a href="mailto:eli@zavedenia.bg"> eli&#64;zavedenia.bg</a>
        <br><br><br>

        <h2>Пловдив</h2>
        <b>Станимир Тончев</b><br>
        /продажби Пловдив, поддръжка сайт/<br>

        <i class="fa fa-envelope"></i> <a href="mailto:st@zavedenia.bg"> st&#64;zavedenia.bg</a>
    </div>

    <div class="contactsInfo">
        <h2>Варна</h2>
        /абонаменти и реклама/<br>
        <!--<i class="fa fa-phone"></i> +359898463472<br>-->
        <i class="fa fa-envelope"></i> <a href="mailto:varna@zavedenia.bg" class="link"> varna&#64;zavedenia.bg</a>
        <br><br><br>
        <h2>Бургас</h2>
        /абонаменти и реклама/<br>
       <!-- <i class="fa fa-phone"></i> +359898463472<br>-->
        <i class="fa fa-envelope"></i> <a href="mailto:burgas@zavedenia.bg" class="link"> burgas&#64;zavedenia.bg</a>
        <br><br><br>
        <h2>Въпроси относно реклама</h2>
        <i class="fa fa-envelope"></i> <a href="mailto:advertising@zavedenia.com" class="link"> advertising&#64;zavedenia.com</a>

    </div>

  </div>
  <div data-language="language == 'mk'" *ngIf="selectedLang === 'mk'">

    <h1>Zavedenia .бг Контакт</h1>

    <p>
      <img src="https://sofia.zavedenia.com/assets/images/zavedenia-logo.svg">
      <br><br>
      Контактирајте нè доколку имате прашања или предлози.<br><br>

      <b class="bold">Контактирајте нè доколку сте сопственик на угостителски објект.</b> Ќе ви понудиме соодветни услови за да допрете до вашите клиенти на ефикасен начин. Можете квалитетно да ги претставите вашите главни услуги, вид на кујна, интересни факти за вашето работење, како и што ве издвојува од останатите. Доколку сакате да се истакнете - користете дополнителна реклама со банери, понуди и присуство на нашите специјални тематски страници. Активирајте онлајн нарачки на храна, како и онлајн резервации - услуги кои се сосема соодветни за денешните услови.<br> Прашajте како, на телефонските броеви подолу.<br><br>

      <b class="bold">Контактирајте нè доколку сте трговец и/или огласувач</b> на производи и услуги поврзани со угостителството. Ќе го најдеме најдобриот канал за да стигнете до што поголем број потенцијални клиенти.<br><br>

      Веќе над 15 години учиме од македонската угостителска индустрија. Одговараме на барањата на сопствениците, но и на клиентите. Знаеме дека многу луѓе секојдневно бараат ресторани преку интернет. Без разлика дали е за специјален повод, одреден вид на кујна или готвач – клиентите секогаш проверуваат, читаат и споредуваат пред да донесат одлука. Во 21 век, интернетот е алатка која заштедува време и скратува растојание.
    </p>

    <div class="contactsInfo">
      <h2>Скопје</h2>
      <b>Ѓорѓи Дангалаков</b><br>
      /претплати и реклама/<br>

      <i class="fa fa-envelope"></i> <a href="mailto:georgid@zavedenia.bg">georgid&#64;zavedenia.bg</a>
      <br><br>
      <b>Елена Јорданова</b><br>
      /содржина на сајтот, сметководство, nahotel.bg/<br>

      <i class="fa fa-envelope"></i> <a href="mailto:eli@zavedenia.bg">eli&#64;zavedenia.bg</a>
      <br><br><br>

      <h2>Битола</h2>
      <b>Станимир Тончев</b><br>
      /продажби и поддршка/<br>

      <i class="fa fa-envelope"></i> <a href="mailto:st@zavedenia.bg">st&#64;zavedenia.bg</a>
    </div>

    <div class="contactsInfo">
      <h2>Охрид</h2>
      /претплати и реклама/<br>
      <i class="fa fa-envelope"></i> <a href="mailto:varna@zavedenia.bg" class="link">varna&#64;zavedenia.bg</a>
      <br><br><br>

      <h2>Прилеп</h2>
      /претплати и реклама/<br>
      <i class="fa fa-envelope"></i> <a href="mailto:burgas@zavedenia.bg" class="link">burgas&#64;zavedenia.bg</a>
      <br><br><br>

      <h2>Прашања за рекламирање</h2>
      <i class="fa fa-envelope"></i> <a href="mailto:advertising@zavedenia.com" class="link">advertising&#64;zavedenia.com</a>
    </div>

  </div>
  <div data-language="language == 'sr'" *ngIf="selectedLang === 'sr'">

    <h1>Zavedenia .бг Kontakt</h1>

    <p>
      <img src="https://sofia.zavedenia.com/assets/images/zavedenia-logo.svg">
      <br><br>
      Kontaktirajte nas ako imate pitanja ili preporuke.<br><br>

      <b class="bold">Kontaktirajte nas ako ste vlasnik ugostiteljskog objekta.</b> Ponudićemo vam odgovarajuće uslove da efikasno dođete do vaših klijenata. Možete kvalitetno predstaviti glavne usluge, tip kuhinje, zanimljive činjenice o vašem objektu, kao i po čemu se razlikujete od drugih. Ako želite da se istaknete – iskoristite dodatnu reklamu sa banerima, ponudama, prisustvom na našim specijalnim tematskim stranicama. Aktivirajte online porudžbine hrane kao i online rezervacije – usluge koje su u potpunosti prilagođene današnjim uslovima.<br> Pitajte kako – na brojevima telefona ispod.<br><br>

      <b class="bold">Kontaktirajte nas ako ste trgovac i/ili oglašivač</b> proizvoda i usluga vezanih za ugostiteljstvo. Pronaći ćemo odgovarajući kanal da dođete do maksimalnog broja potencijalnih klijenata.<br><br>

      Već više od 15 godina učimo iz srpske ugostiteljske scene. Odgovaramo i na zahteve vlasnika i na zahteve klijenata. Znamo koliko ljudi svakodnevno traži restorane preko interneta. Bilo da je reč o posebnoj prilici, određenom tipu kuhinje ili kuvaru – klijenti uvek istražuju pre nego što odluče. U 21. veku, internet štedi vreme i smanjuje razdaljinu – to je velika prednost za svakoga.
    </p>

    <div class="contactsInfo">
      <h2>Beograd</h2>
      <b>Đorđe Dangalakov</b><br>
      /pretplate i reklama/<br>

      <i class="fa fa-envelope"></i> <a href="mailto:georgid@zavedenia.bg">georgid&#64;zavedenia.bg</a>
      <br><br>
      <b>Elena Jordanova</b><br>
      /sadržaj sajta, računovodstvo, nahotel.bg/<br>

      <i class="fa fa-envelope"></i> <a href="mailto:eli@zavedenia.bg">eli&#64;zavedenia.bg</a>
      <br><br><br>

      <h2>Novi Sad</h2>
      <b>Stanimir Tončev</b><br>
      /prodaja i podrška sajtu/<br>

      <i class="fa fa-envelope"></i> <a href="mailto:st@zavedenia.bg">st&#64;zavedenia.bg</a>
    </div>

    <div class="contactsInfo">
      <h2>Niš</h2>
      /pretplate i reklama/<br>
      <i class="fa fa-envelope"></i> <a href="mailto:varna@zavedenia.bg" class="link">varna&#64;zavedenia.bg</a>
      <br><br><br>

      <h2>Kragujevac</h2>
      /pretplate i reklama/<br>
      <i class="fa fa-envelope"></i> <a href="mailto:burgas@zavedenia.bg" class="link">burgas&#64;zavedenia.bg</a>
      <br><br><br>

      <h2>Pitanja o oglašavanju</h2>
      <i class="fa fa-envelope"></i> <a href="mailto:advertising@zavedenia.com" class="link">advertising&#64;zavedenia.com</a>
    </div>

  </div>

  <!--

     <div class="our_sites">
     Нашите запазени марки:<br><br>
     Zavedenia.bg ©, България<br>
     <img src="https://zavedenia.com/system/application/views/html/bg/images/zavedenia.gif" alt="Zavedenia.bg - ресторанти, барове, клубове"><br>
     Estiatoria ©, Гърция <br>
     <img src="https://zavedenia.com/system/application/views/html/bg/images/estiatoria.gif" alt="Estiatoria"><br>
     наХотел ©, България<br>
     <img src="https://zavedenia.com/system/application/views/html/bg/images/nahotel.gif" alt="NaHotel.bg - хотели, къщи за гости">
     </div>

        <table class="forma" style="font-size:11px;">
        <tbody><tr>
        <td class="text-red12" width="160" valign="top">

       </td>
       <td style="width:10px;"></td>
       <td valign="top" class="text-red11">
       <b class="bold">Адресите, на които ще ни намерите:</b><br><br>
       България:<br>

       <a href="http://www.zavedenia.bg" target="_blank" title="ресторанти, барове, клубове">www.zavedenia.bg</a><br>
       <a href="http://www.zavedenia.net" target="_blank" title="заведения">www.zavedenia.net</a><br>
       <a href="http://www.zavedenia.biz" target="_blank" title="нашите сайтове за заведения">www.zavedenia.biz</a><br>
       <a href="http://www.zavedenia.org" target="_blank" title="блог за кулинария и заведения">www.zavedenia.org</a><br>
       <a href="http://www.zavedenia.info" target="_blank" title="за ресторантьори и хотелиери">www.zavedenia.info</a><br>

       </td></tr></tbody></table>
-->

  </div>
  </div>
</div>

